import CustomButton from "@/components/custom-button/custom-button";

import { Divider, Typography } from "antd";
import { styled } from "styled-components";

const DescriptionBenefit = styled.p`
  width: 100%;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  font-feature-settings: 'liga' off, 'clig' off;
  text-align: left;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;

const TotalAvailableStyled = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 0 auto;
  width: auto;

  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;

  p {
    margin: 0;
    width: 100%;
    max-width: 296px;
    box-sizing: border-box;
  }
  span {
    font-weight: 700;
    box-sizing: border-box;
  }
`;

const ButtonStyled = styled(CustomButton)`
  &.custom-button {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
    box-sizing: border-box;
  }
`;

const ContentInfoBalanceStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;

  @media (max-width: 768px) {
    flex-direction: column;

    .divider{
      width: 100%;
      height: 1px;
      border-left: none;
      border-bottom: 1px solid ${({ theme }) => theme?.colors?.text?.muted};
    }
  }
`;

const ContainerCardBalanceStyled = styled.div`
  display: flex;
  height: 56.698px;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

const Icon = styled.img`
  width: 48px;
  height: 48px;
  margin-right: 16px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled(Typography)`
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "Red Hat Display", Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 200%; /* 32px */
  color: ${({ theme }) => theme?.colors?.text?.headings};
`;

const Description = styled.p`
  font-feature-settings: 'liga' off, 'clig' off;


  font-family: "Red Hat Display", Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
  color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
`;

const ContentBodyStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

const ContentSuccessStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const TextSuccessStyled = styled.span`
  font-family: "Red Hat Display", Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
  color: ${({ theme }) => theme?.colors?.theme?.success};
`;

const ButtonSuccessStyled = styled.button`
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-decoration: underline;
  color: ${({ theme }) => theme?.colors?.text?.headings};
`;

const DividerButtonsStyled = styled(Divider)`
  margin: 0px;
  padding: 0px;
  border-color: ${({ theme }) => theme.colors.text.neutral};
`;


export {
  TotalAvailableStyled,
  ButtonStyled,
  ContentInfoBalanceStyled,
  ContainerCardBalanceStyled,
  Icon,
  TextContainer,
  Title,
  Description,
  DescriptionBenefit,
  ContentBodyStyled,
  ContentSuccessStyled,
  TextSuccessStyled,
  ButtonSuccessStyled,
  DividerButtonsStyled
};